// Übergibt Nutzer-/Händler-Identität an Microsoft Clarity.
// No-op, wenn Clarity nicht geladen ist (z. B. Umgebungen ohne VUE_APP_CLARITY_ID).
export function identifyInClarity () {
  if (typeof window.clarity !== 'function') return
  const userId = sessionStorage.getItem('userId')
  const companyId = sessionStorage.getItem('companyId')
  if (userId) window.clarity('identify', userId)
  if (companyId) window.clarity('set', 'companyId', companyId)
}
